<template>
  <ul class="context-menu-container">
    <li @click="onRefreshClick">
      {{ '刷新' }}
    </li>
    <li @click="onCloseRightClick">
      {{ '关闭右侧' }}
    </li>
    <li @click="onCloseOtherClick">
      {{ '关闭其他' }}
    </li>
  </ul>
</template>

<script setup>
import { defineProps } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
const props = defineProps({
  index: {
    type: Number,
    required: true
  }
})

const router = useRouter()
const onRefreshClick = () => {
  router.go(0)
}

const store = useStore()
const onCloseRightClick = () => {
  store.commit('app/removeTagsView', {
    type: 'right',
    index: props.index
  })
}

const onCloseOtherClick = () => {
  store.commit('app/removeTagsView', {
    type: 'other',
    index: props.index
  })
}
</script>

<style lang="scss" scoped>
.context-menu-container {
  position: fixed;
  background: #fff;
  z-index: 3000;
  list-style-type: none;
  padding: 6px;
  border: 1px solid var(--admin-color-border-soft);
  border-radius: 8px;
  font-size: 12px;
  font-weight: 400;
  color: var(--admin-color-text-regular);
  box-shadow: var(--admin-shadow-popover);
  li {
    margin: 0;
    padding: 8px 14px;
    border-radius: 6px;
    cursor: pointer;
    &:hover {
      color: var(--admin-color-primary);
      background: #eff6ff;
    }
  }
}
</style>
